import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, TablePagination, Chip, CircularProgress } from "@mui/material";
import axiosInstance from "../../utilities/Axios";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useNavigate } from "react-router-dom";
import { ProcessEnum, ProcessEnumDisplayLabel } from "../../Types/Enum";
import { enqueueSnackbar } from "notistack";
import { AssignmentInd, DeveloperBoard, SendOutlined } from "@mui/icons-material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { Can } from "../../utilities/util";

const RegistrationTable = (props: { filter: any }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);

  const [registrationList, setRegistrationList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [value, setValue] = useState({});
  const { changeLoading, isLoading } = React.useContext(LoadingStateContext);


  useEffect(() => {
    getRegistrationsList();
  }, [page, limit, props.filter, value]);

  const getRegistrationsList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(`/v1/registrations?type_dom_corp=${theme.theme}&page=${page + 1}&items_per_page=${limit}`, {
        params: props.filter,
      });

      const data = response.data;
      setRegistrationList(data.result.data);

      setTotalItems(data.result.total);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };


  const refresh = () => {
    setValue({});
  };

  const createProcesses = async (resume_id: number, country_process_id: number) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process`;

      const res = await axiosInstance.post(url, {
        resume_id: resume_id,
        country_process_id: country_process_id,
        status: ProcessEnum.processing,
        note: "",
      });
      getRegistrationsList();
      enqueueSnackbar("Country Process Started!");
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Failed to Start Country Process!!!!");
    }
  };

  return (
    <>
      <Paper>
        <TableContainer component={Paper}>
          <Table aria-label="registration table">
            <TableHead>
              <TableRow>
                <TableCell>Reference</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>First Name</TableCell>
                <TableCell>Passport No:</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Job Title</TableCell>
                <TableCell>Country Code</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {isLoading &&
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              }
              {!isLoading && registrationList && registrationList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
              {!isLoading && registrationList.map((data: any, key: number) => (
                <TableRow key={key}>                  
                  <TableCell>{data.customer_reference}</TableCell>
                  <TableCell>{new Date(data.updated_at).toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' })}</TableCell>
                  <TableCell>{data.first_name}</TableCell>
                  <TableCell>{data.passport_no}</TableCell>
                  <TableCell align="center">
                    <Chip
                      className="text-[10px] font-[bold]"
                      size="small"
                      label={ProcessEnumDisplayLabel[data.status]}
                      color={
                        data.status == ProcessEnum.started ||
                          data.status == ProcessEnum.processing ||
                            data.status == ProcessEnum.completed
                          ? "success"
                          : "error"
                      }
                    />
                  </TableCell>
                  <TableCell>{data.title}</TableCell>
                  <TableCell>{data.country_code}</TableCell>
                  <TableCell>{data.type === 'dom' ? <Chip label="Domestic" /> : <Chip label="Corporate" />}</TableCell>
                  <TableCell>
                    {Can("resume", ["VIEW"]) && (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        endIcon={<SendOutlined />}
                        onClick={() => {
                          navigate({
                            pathname: "/admin/pdf",
                            search: `?resumeId=${data.resume_id}&countryProcess=${data.country_process_id}`,
                          });
                        }}
                      >
                        Generate Resume
                      </Button>
                    )}{" "}
                    {data.status === "created" ? (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        endIcon={<SendOutlined />}
                        onClick={() => {
                          createProcesses(data.resume_id, data.country_process_id);
                        }}
                      >
                        Process
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        endIcon={<SendOutlined />}
                        onClick={() => {
                          navigate({
                            pathname: "/admin/process-view",
                            search: `?processId=${data.process_id}`,
                          });
                        }}
                      >
                        Process
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            count={totalItems}
            rowsPerPage={limit}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>

      </Paper>
      <div className="h-12"></div>
    </>
  );
};

export default RegistrationTable;
